<div class="loading-overlay" [class.visible]="visible">
    <div class="loading-content">
      <div class="spinner"></div>
      <h2 class="loading-title">{{ title }}</h2>
      <p class="loading-message">{{ message }}</p>
    </div>
  </div>